import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class NewButtonModel extends ButtonBase {
    label: string = 'New';
    action: string = ACTION_STATUS.new;
    matIconName: string = 'add';
    colorClass: string = 'color-success-500';
}